import React from "react";
import TextArea from "canvas-core-react/lib/TextArea";
import { useTranslation } from "react-i18next";

import CustomInput from "../../shared/custom-components/customInput";
import CustomSelect from "../../shared/custom-components/customSelect";
import StepButtons from "./stepButtons";
import useForm from "../../hooks/useForm";

const ContractForm = ({ initialState, reviewMode, previousStep, nextStep }) => {
  const { errors, values, handleChange, onSubmit, setMultipleValues } = useForm(
    {
      initialState,
      validation,
      callback: (values) => nextStep(values),
    }
  );

  const { t } = useTranslation();

  return (
    <>
      {getContractDescription(t, reviewMode, values)}
      <div className={`register-provider-form ${!reviewMode ? "mt-5" : ""}`}>
        {!reviewMode &&
          Object.keys(items).map((key) => {
            const { name, select, options, ...restProps } = items[key];

            const Component = select ? CustomSelect : CustomInput;

            const selectOptions = select
              ? !values.gender && name === "maritalStatus"
                ? []
                : options.map((value) => {
                    const itemLabel = t(
                      `${baseName}form.${name}Options.${value}`,
                      { key: values.gender === "Mujer" ? "a" : "o" }
                    );
                    return { label: itemLabel, value: itemLabel };
                  })
              : undefined;

            const label = t(`${baseName}form.${name}`);

            const onChange = (e) => {
              if (e.target.name !== "gender") handleChange(e);
              else
                setMultipleValues([
                  { name: "maritalStatus", value: "" },
                  { name: "gender", value: e.target.value },
                ]);
            };

            return (
              <Component
                key={key}
                name={name}
                label={`[${key}] ${label}`}
                placeholder={
                  select ? `Seleccione su ${label.toLocaleLowerCase()}` : label
                }
                items={selectOptions}
                error={errors[name]}
                value={values[name]}
                onChange={onChange}
                className={
                  select ? "select-margin-fix" : "input-new-provider-fix"
                }
                {...restProps}
              />
            );
          })}
        <div className="my-4">
          <TextArea
            className="text-area-heigth-fix"
            label={t(`${baseName}form.address`)}
            onChange={handleChange}
            name="address"
            error={errors.address}
            errorMsg={errors.address}
            value={values.address}
            disabled={reviewMode}
            placeholder="Dirección"
          />
        </div>
      </div>

      {!reviewMode && (
        <StepButtons nextStep={onSubmit} previousStep={previousStep} />
      )}
    </>
  );
};

export default ContractForm;

const getContractDescription = (t, reviewMode, values) => {
  const description = t(
    `${baseName}formDescription`,
    Object.keys(items).reduce((acc, current) => {
      acc[current] = reviewMode ? values[items[current].name] : `[${current}]`;
      return acc;
    }, {})
  );

  const titleClass = `form-title  ${reviewMode ? "my-4" : "mb-5"}`;

  return (
    <>
      {reviewMode && <hr style={{ marginTop: 40 }} />}
      <h3 className={titleClass}>{t(`${baseName}title`)}</h3>
      {!reviewMode && (
        <h3 className="form-title w-100 text-left my-3">
          {t(`${baseName}subtitle`)}:
        </h3>
      )}
      <p
        className="font-weight-normal"
        dangerouslySetInnerHTML={{ __html: description }}
      ></p>
    </>
  );
};

const baseName = "registerProvider.forms.contract.";

const items = {
  a: { name: "providerName" },
  f: { name: "representativeName" },
  k: { name: "city" },
  b: { name: "society" },
  g: {
    name: "gender",
    select: true,
    options: ["male", "female"],
  },
  l: {
    name: "businessIdType",
    select: true,
    options: ["identificationCard", "passport"],
  },
  c: { name: "country" },
  h: { name: "nationality" },
  m: { name: "businessId" },
  d: { name: "registered" },
  i: {
    name: "maritalStatus",
    select: true,
    options: ["single", "married"],
  },
  n: { name: "conditional" },
  e: { name: "from" },
  j: { name: "profession" },
  o: { name: "consists" },
};

const validation = {
  providerName: { required: true },
  representativeName: { required: true },
  city: { required: true },
  society: { required: true },
  gender: { required: true },
  businessIdType: { required: true },
  country: { required: true },
  nationality: { required: true },
  businessId: { required: true },
  registered: { required: true },
  maritalStatus: { required: true },
  conditional: { required: true },
  from: { required: true },
  profession: { required: true },
  consists: { required: true },
  address: {
    required: true,
    maxLength: {
      parameters: { len: 150 },
      msg: "Debe tener una longitud máxima de 150 caracteres",
    },
  },
};
